import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import FormikInputField from 'components/common/Fields/FormikInputField';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import { Button, Card, CardBody, Col, Container, FormGroup, Input, InputGroup, InputGroupText, Label, Row, UncontrolledTooltip } from 'reactstrap'
import Calendar from 'assets/icon/calendar-icon.svg';
import DatePicker from "react-datepicker";
import ReactInputMask from 'react-input-mask';
import React, { useState } from 'react'
import { Formik,Filed, Field } from 'formik';
import NDCList from 'components/NDCList';
import { toast } from "react-toastify";
import useAxios from 'hooks/useAxios';
import moment from "moment";
import Tooltip from 'react-tooltip-lite'
import HoverImage from 'react-hover-image/build';
import Question from 'assets/icon/icons8-question-mark.svg'
import DrugExclusionNDC from 'components/NDCList/DrugExclusionNDC';
import Loader from 'components/Loader';
import plus from "assets/icon/plus-icon.svg";
import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";
import save from "assets/icon/save.svg";
import cancel from "assets/icon/cancel.svg";



let hasDatePopupOpen = false;
let ndcerror = 'NDC is a required field'
let NDCerror = "Drug Name is a required field";
let ReasonErr = "Reason is a required field";
let StartErr = "Start Date is a required field"
const AddDrugExclusion = (props) => {
  const {Covered,orgId,toggle,refetch,onSearch,filters,handleSubmit1}=props;
  console.log(Covered,"Covered IN Add")
  const API = useAxios();

  const initialValues = {
    ndc: '',
    ndcDesc:'',
    commentValue:'', 
    reason:''
};
let ReasonEdit= [
  {
    "id":"2370",
    "label":"Orphan Drug"
  },
  {
    "id":"2400",
    "label":"Non-Covered Drug"
  }
]
  const [selectedNdc, setSelectedNdc] = useState("");
  const [ndcNum,setNdcNum] = useState("");
  const [selectedNdcDesc, setSelectedNdcDesc] = useState("");
  const [reason, setReason] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(null);
  const [commentAdd, setCommentAdd] = useState(null);
  const [NDCSelected,hasNDCSelected] = useState(false);
  const [NDCdescSelected,hasNDCdescSelected] = useState(false);

  const [reasonSelected,hasReasonSelected] = useState(false);
  const [startDateSelected,hasStartDateSelected] = useState(false);
  const [dateerror, setDateError] = useState("");
  const [NDCerr,setNDCErr] = useState(false);
  const [loading, setLoading] = useState(false);


    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };
    const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
    
        }
    };
    const handleReason = (selectedOption) => {
      if(selectedOption){
        setReason(selectedOption.target.value); 
        hasReasonSelected(false);
      }
      else{
        hasReasonSelected(true);
        // setReason("");
      }
      debugger;
      
    };
    const handleNdc = (ndc) => {
      debugger;
      if (ndc !== null) {
        setSelectedNdc(ndc) !== ndc
        // setFieldValue('ndc', ndc.id.toString());
        setSelectedNdcDesc(ndc.description);
        setNdcNum(ndc.id);
        if (error == false) {
          seterror(false);
        }
        hasNDCSelected(false);
        hasNDCdescSelected(false);
      }
      else {
        setSelectedNdc(null)
        setSelectedNdcDesc("")
        // setFieldValue('ndc', null);
        hasNDCSelected(true);
        hasNDCdescSelected(true);
      }
          //  console.log(selectedNdc,"NDC",ndc)

    };
    // const handleNDCdesc = () =>{
      
    //   if(selectedNdcDesc === ""){
    //     setFieldValue('Desc', ndc.description)
    //     setSelectedNdcDesc(ndc.description);
    //     hasNDCdescSelected(false);
    //   }
    //   else{
    //     hasNDCdescSelected(true);
    //   }
    // }
    const handleStartDate = (startDate) => {
      if(startDate){
        setDateError("");
        // var stnDate = moment(new Date(startDate)).format(
        //   'MM/DD/YYYY'
        // );
        var stnDate = startDate;
        setStartDate(stnDate);
        hasStartDateSelected(false);
      }
      else{
        // setStartDate(null);
        hasStartDateSelected(true);
      }
      
      
     
  };
  const handleEndDate = (endDate) => {
    var enDate = moment(new Date(endDate)).format(
      'MM/DD/YYYY'
    );
    setEndDate(enDate);
  
};
const handleCommentChange = (e, setFieldValue) => {
  const { value } = e.target;
 
  setFieldValue('commentValue', value);
  setCommentAdd(value);
  
};
const handleSave= async()=>{
  debugger;
  setLoading(true)
  if(ndcNum === "")
  {
    hasNDCSelected(true);
    hasNDCdescSelected(true);
  }
  else{
    hasNDCSelected(false);
    hasNDCdescSelected(false);
  }
  if(reason.length > 0){
    hasReasonSelected(false);
  }
  else{
    hasReasonSelected(true);
  }
  if (startDate.length==0) {
    setDateError("Start Date is a required field");
    setLoading(false);
  }
  // if(selectedNdcDesc === "")
  // {
    
  // }
  // else{
    
  // }
    debugger
    var list = {};
    list.NDC = ndcNum.toString();
    list.DrugName = selectedNdcDesc;
    list.Reason = reason;
    list.StartDate = moment(startDate).format("MM/DD/YYYY");
    list.EndDate =endDate == null ? null : moment(endDate).format("MM/DD/YYYY");
    list.UserNotes=commentAdd;
    if (!list.NDC || !list.DrugName || !list.Reason || !list.StartDate) {
      // hasNDCdescSelected(false);
    } 
    else 
    {
      try {
        const { data } = await API.post(
          `SBTenant/${orgId.tenantID}/DrugCatalog/SaveDrugExclusion/${Covered}`,
          list,
          {
            hasDefaultURL: true,
          }
        );
        if (data.error == true) {
          // toast.error(data.message);
          setNDCErr(true);
          //return setNDCErr(true);
          
        }
         
        else {
          toast.success(data.message);
          toggle();
          // refetch(filters);
          //  refetch(accumualator,selectedHospital);
          refetch(Covered);
        }
        setLoading(false);
      } 
      catch (error) {
        console.log(error);
        setLoading(false);
      }
      setLoading(false);

    }
}
const cancelDrawer = () => {
  toggle();
  setSelectedNdcDesc("")
  setNdcNum("");
  setSelectedNdc("");
  setReason("");
  setStartDate(null);  
  setEndDate(null);   
  setCommentAdd(""); 
  hasNDCSelected(false);
  hasReasonSelected(false);
  hasStartDateSelected(false);
};
const handleNDcDisc = (e) => {
  debugger;
  if (e) {
    setSelectedNdcDesc(e.target.value);
    // hasNDCdescSelected(false);
  } 
  // else {
  //   hasNDCdescSelected(true);
  // }
  // if(error == false){
  //     seterror(false);

  // }
  //seterror(false);
};
    const [error, seterror] = useState(false);
  return (
    <div>
        <div>
            <Card>
                <CardBody>
            {loading && (
              <div className="justify-content-center">
                <Loader />
              </div>
            )}
                <Formik
                             initialValues={initialValues}
                            //  onSubmit={handleSubmit}
                            //  enableReinitialize={true}
                            children={(props) => {
                                 const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                                return (
                                  <div hidden={""}>
                                    <Row sm={5}>
                                      <Col
                                        md={2}
                                        lg={3}
                                        sm={6}
                                        xs={6}
                                        className="required"
                                      >
                                        {" "}
                                        <FormGroup>
                                          <Label for="ndc">NDC</Label>
                                          <DrugExclusionNDC
                                            name="ndc"
                                            onSelect={(value) =>
                                              handleNdc(value)
                                            }
                                            
                                            selectedNDC={selectedNdc}
                                          />
                                          {(NDCSelected) ? (
                                        <div className="text-danger f-12">
                                            {ndcerror}
                                        </div>
                                    ) : null}
                                        </FormGroup>
                                      </Col>

                                      <Col md={2} lg={3} sm={6} xs={6}>
                                        {" "}
                                        <FormGroup>
                                          <Label for="drugname">
                                            Drug Name
                                          </Label>
                                          <Input
                                            className="required drugNamedisable"
                                            id="drugname"
                                            name="drugname"
                                            type="text"
                                           // placeholder="Enter Drug Name "
                                            // autoComplete="off"
                                            value={selectedNdcDesc}
                                            component={FormikInputField}
                                            onChange={handleNDcDisc}
                                            disabled
                                          />
                                          {(NDCdescSelected) ? (
                                            <div className="text-danger f-12">
                                              {NDCerror}
                                            </div>
                                          ) : null}
                                        </FormGroup>
                                      </Col>
                                      <Col md={2} lg={3} sm={6} xs={6}>
                                        {" "}
                                        <FormGroup>
                                          <Label for="reason">Reason</Label>
                                          <Field
                                            className="required"
                                            name="reason"
                                            options={ReasonEdit} // Pass the ReasonEdit array as options
                                            component={FormikSelectField} // Use the custom FormikSelectField
                                            value={reason} // Set the value to the selected option
                                            defaultoption="--Select--"
                                            keys={{
                                              id: "id",
                                              label: "label",
                                            }}
                                            onChange={handleReason}
                                          />
                                          {reasonSelected ? (
                                            <div className="text-danger f-12">
                                              {ReasonErr}
                                            </div>
                                          ) : null}
                                        </FormGroup>
                                      </Col>
                                      <Col
                                        md={3}
                                        sm={3}
                                        xs={6}
                                        className="required-date"
                                      >
                                        <Row className='d-flex'>
                                          <Col>
                                            <FormGroup>
                                              <Label>Start Date</Label>
                                              <InputGroup
                                                onMouseLeave={handleMouseLeave}
                                              >
                                                <DatePicker
                                                  id="startDate"
                                                  name="startDate"
                                                  selected={startDate}
                                                  onChange={(e) => {
                                                    handleStartDate(e);
                                                  }}
                                                  minDate={
                                                    new Date(
                                                      new Date().setDate(
                                                        new Date().getDate() + 1
                                                      )
                                                    )
                                                  }
                                                  dateFormat="MM/dd/yyyy"
                                                  placeholderText="Select a date"
                                                  autoComplete="off"
                                                  // showMonthYearPicker={true}
                                                  // showFullMonthYearPicker={true}
                                                  // showYearPicker={true}
                                                  customInput={
                                                    <ReactInputMask
                                                      mask="99/99/9999"
                                                      value={startDate}
                                                    />
                                                  }
                                                />

                                                <InputGroupText
                                                  onClick={() =>
                                                    handleDateClick("startDate")
                                                  }
                                                >
                                                  <img src={Calendar} alt="" />
                                                </InputGroupText>
                                              </InputGroup>
                                              {dateerror ? (
                                                <div className="text-danger f-12">
                                                  {dateerror}
                                                </div>
                                              ) : null}
                                            </FormGroup>
                                          </Col>
                                          <Col md={1} style={{ marginTop: 38 }}>
                                            <Tooltip
                                              content={
                                                <div className="tip-list-info">
                                                  <p>
                                                    <strong>
                                                      Start Date :{" "}
                                                    </strong>
                                                    <span>
                                                      {" "}
                                                      The system will ensure
                                                      this NDC is 'Always
                                                      Purchased at GPO' on the
                                                      next business day or the
                                                      exact date, if a future
                                                      effective date is chosen.
                                                      NOTE: If any Purchase
                                                      Orders are split prior to
                                                      the Effective Date, the
                                                      system will not 'Always
                                                      Purchase at GPO'.
                                                    </span>
                                                  </p>
                                                </div>
                                              }
                                              direction="right"
                                              tagName="span"
                                              className="target"
                                              tipContentClassName=""
                                              zIndex={99999}
                                            >
                                              <span className="cursor-pointer text-decoration-underline">
                                                <HoverImage
                                                  src={Question}
                                                  hoverSrc={Question}
                                                  style={{ width: '20px', height: '20px' }}
                                                ></HoverImage>
                                              </span>
                                            </Tooltip>
                                          </Col>
                                        </Row>
                                      </Col>
                                      <Col
                                        md={3}
                                        sm={3}
                                        xs={6}
                                        className="notrequired-date-endDate"
                                      >
                                        <Row className='d-flex'>
                                          <Col>
                                            <FormGroup>
                                              <Label>End Date</Label>
                                              <InputGroup
                                                onMouseLeave={handleMouseLeave}
                                              >
                                                <DatePicker
                                                  id="endDate"
                                                  name="endDate"
                                                  selected={endDate}
                                                  onChange={(e) => {
                                                    handleEndDate(e);
                                                  }}
                                                  minDate={startDate ? new Date(startDate) : new Date(
                                                    new Date().setDate(
                                                      new Date().getDate() + 1
                                                    )
                                                  )}
                                                  // maxDate={new Date()}
                                                  dateFormat="MM/dd/yyyy"
                                                  placeholderText="Select a date"
                                                  autoComplete="off"
                                                  customInput={
                                                    <ReactInputMask
                                                      mask="99/99/9999"
                                                      value={endDate}
                                                    />
                                                  }
                                                />
                                                <InputGroupText
                                                  onClick={() =>
                                                    handleDateClick("endDate")
                                                  }
                                                >
                                                  <img src={Calendar} alt="" />
                                                </InputGroupText>
                                              </InputGroup>
                                            </FormGroup>
                                          </Col>
                                          <Col md={1} style={{ marginTop: 35, marginRight:10 }}>
                                            <Tooltip
                                              content={
                                                <div className="tip-list-info">
                                                  <p>
                                                    <strong>End Date : </strong>
                                                    <span>
                                                      {" "}
                                                      The system will ensure
                                                      this NDC is removed from
                                                      'Always Purchase at GPO'
                                                      on the next business day
                                                      or the exact date, if a
                                                      future end date is chosen.
                                                      NOTE: If any Purchase
                                                      Orders are split prior to
                                                      the End Date, the system
                                                      will 'Always Purchase at
                                                      GPO'.
                                                    </span>
                                                  </p>
                                                </div>
                                              }
                                              direction="right"
                                              tagName="span"
                                              className="target"
                                              tipContentClassName=""
                                              zIndex={99999}
                                            >
                                              <span className="cursor-pointer text-decoration-underline">
                                                <HoverImage
                                                  src={Question}
                                                  hoverSrc={Question}
                                                  style={{ width: '20px', height: '20px' }}
                                                ></HoverImage>
                                              </span>
                                            </Tooltip>
                                          </Col>
                                        </Row>
                                      </Col>
                                      <Col md={3} lg={3} sm={6} xs={6}>
                                        {" "}
                                        <FormGroup>
                                          <Label for="comments">Comments</Label>
                                          <Input
                                            id="comments"
                                            name="comments"
                                            type="text"
                                            // className="required"
                                            placeholder="Enter Comments "
                                            autoComplete="off"
                                            value={commentAdd}
                                            component={FormikInputField}
                                            onChange={(e) => {
                                              handleCommentChange(
                                                e,
                                                setFieldValue
                                              );
                                            }}
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>

                                    <Row style={{
                    justifyContent: "flex-end",
                    // marginRight: "10px",
                  }}>
                                    {NDCerr && <span className="text-danger font-size-12">NDC Exclusion already exists</span>}
                                      <Col md="auto">
                                      <Button
                                          color="primary"
                                          className="search ms-3"
                                          onClick={handleSave}
                                          //   disabled = {addDisabled}
                                        >
                                          <span className="right_5">
                                                                <img src={save} alt="" />
                                                              </span>{" "}
                                          Save
                                        </Button>
                                        <Button
                                          color="primary"
                                          className="reset"
                                          // onClick={handleSubmit}
                                          //  onClick={addReset}
                                          onClick={cancelDrawer}
                                          // disabled = {addDisabled}
                                        >
                                          <span className="right_5">
                                                                <img src={cancel} alt="" />
                                                              </span>{" "}
                                          Cancel
                                        </Button>
                                      
                                      </Col>
                                    </Row>
                                  </div>
                                );
                            }}></Formik>
                </CardBody>
            </Card>
        </div>
    </div>
  )
}

export default AddDrugExclusion